import { Component } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, NgOptimizedImage],
  template: `
    <!-- Overlay for mobile sidebar -->
    <div class="overlay" [class.overlay-active]="isMenuOpen" (click)="closeMenu()"></div>
    
    <header class="header">
      <div class="container">
          <div class="nav-brand">
            <a class="logo" routerLink="/">
              <img ngSrc="assets/kse-logo-header.png" alt="KSE Solutions" class="logo-image" width="550" height="180" priority>
            </a>
          </div>
        
        <!-- Desktop Navigation -->
        <nav class="nav desktop-nav">
          <ul class="nav-list">
            <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Startseite</a></li>
            <li><a routerLink="/netzbau" routerLinkActive="active">Netzbau</a></li>
            <li><a routerLink="/systemtechnik" routerLinkActive="active">Systemtechnik</a></li>
            <li><a routerLink="/ueber-uns" routerLinkActive="active">Über uns</a></li>
            <li><a routerLink="/kontakt" routerLinkActive="active" class="contact-btn">Kontakt</a></li>
          </ul>
        </nav>

        <!-- Mobile Sidebar -->
        <nav class="sidebar" [class.sidebar-open]="isMenuOpen">
          <div class="sidebar-header">
            <span class="sidebar-logo">KSE Solutions</span>
            <button class="close-btn" (click)="closeMenu()">
              <span>&times;</span>
            </button>
          </div>
          <ul class="sidebar-nav">
            <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">Startseite</a></li>
            <li><a routerLink="/netzbau" routerLinkActive="active" (click)="closeMenu()">Netzbau</a></li>
            <li><a routerLink="/systemtechnik" routerLinkActive="active" (click)="closeMenu()">Systemtechnik</a></li>
            <li><a routerLink="/ueber-uns" routerLinkActive="active" (click)="closeMenu()">Über uns</a></li>
            <li><a routerLink="/kontakt" routerLinkActive="active" (click)="closeMenu()">Kontakt</a></li>
          </ul>
        </nav>

        <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  `,
  styles: [`
    .header {
      background-color: white;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      box-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
      backdrop-filter: blur(10px);
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 clamp(1rem, 4vw, 2rem);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: clamp(70px, 10vw, 80px);
    }

    .logo {
      text-decoration: none;
      display: flex;
      align-items: center;
      transition: transform 0.3s ease;
      border: none;
      outline: none;
    }

    .logo:focus {
      outline: none;
      border: none;
    }

    .logo:hover {
      transform: scale(1.05);
    }

    .logo-text {
      font-size: clamp(1.25rem, 3vw, 1.75rem);
      font-weight: bold;
      color: #00a1f3;
      letter-spacing: -0.025em;
    }

    .logo-image {
      height: clamp(110px, 17vw, 180px);
      width: auto;
      max-width: 550px;
      object-fit: contain;
      transition: transform 0.3s ease;
      filter: brightness(1.1) contrast(1.05);
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
    }

    .logo:hover .logo-image {
      transform: scale(1.05);
      filter: brightness(1.15) contrast(1.1);
    }

    .logo:active .logo-image {
      transform: scale(0.98);
    }

    /* Desktop Navigation */
    .desktop-nav {
      display: block;
    }

    .nav-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      gap: clamp(1rem, 3vw, 2rem);
      align-items: center;
    }

    .nav-list a {
      text-decoration: none;
      color: #001635;
      font-weight: 500;
      transition: color 0.3s ease;
      padding: clamp(0.5rem, 1.5vw, 0.75rem) clamp(0.75rem, 2vw, 1rem);
      border-radius: 6px;
      font-size: clamp(0.9rem, 2vw, 1rem);
      position: relative;
      border: none;
      outline: none;
    }

    .nav-list a::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 50%;
      width: 0;
      height: 2px;
      background-color: #00a1f3;
      transition: all 0.3s ease;
      transform: translateX(-50%);
    }

    .nav-list a:hover,
    .nav-list a.active {
      color: #00a1f3;
    }

    .nav-list a:hover::after,
    .nav-list a.active::after {
      width: 80%;
    }

    .nav-list a:focus {
      outline: none;
      border: none;
    }

    .contact-btn {
      background-color: #00a1f3 !important;
      color: white !important;
      transition: all 0.3s ease;
      border: 2px solid #00a1f3;
    }

    .contact-btn::after {
      display: none !important;
    }

    .contact-btn:hover {
      background-color: #0091d3 !important;
      border-color: #0091d3 !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 161, 243, 0.3);
    }

    /* Mobile Sidebar - Hidden by default */
    .sidebar {
      position: fixed;
      top: 0;
      right: -320px;
      width: min(320px, 85vw);
      height: 100vh;
      background-color: #001635;
      transition: right 0.3s ease;
      z-index: 1001;
      display: none;
      box-shadow: -5px 0 20px rgba(0, 0, 0, 0.3);
    }

    .sidebar-open {
      right: 0 !important;
      display: block !important;
    }

    .sidebar-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: clamp(1rem, 4vw, 1.5rem);
      border-bottom: 1px solid #003366;
    }

    .sidebar-logo {
      font-size: clamp(1.1rem, 3vw, 1.25rem);
      font-weight: bold;
      color: #00a1f3;
      letter-spacing: -0.025em;
    }

    .close-btn {
      background: none;
      border: none;
      color: white;
      font-size: clamp(1.5rem, 4vw, 2rem);
      cursor: pointer;
      padding: 0;
      width: clamp(25px, 6vw, 35px);
      height: clamp(25px, 6vw, 35px);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.3s ease;
      border-radius: 50%;
    }

    .close-btn:hover {
      color: #00a1f3;
      background-color: rgba(0, 161, 243, 0.1);
    }


    .sidebar-nav {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .sidebar-nav li {
      border-bottom: 1px solid #003366;
    }

    .sidebar-nav a {
      display: block;
      padding: clamp(1rem, 3vw, 1.25rem) clamp(1.25rem, 4vw, 1.5rem);
      color: white;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.3s ease;
      font-size: clamp(0.95rem, 2.5vw, 1.1rem);
      position: relative;
    }

    .sidebar-nav a::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 0;
      background-color: #00a1f3;
      transition: width 0.3s ease;
    }

    .sidebar-nav a:hover,
    .sidebar-nav a.active {
      background-color: #003366;
      color: #00a1f3;
      padding-left: clamp(1.5rem, 5vw, 2rem);
    }

    .sidebar-nav a:hover::before,
    .sidebar-nav a.active::before {
      width: 4px;
    }

    /* Overlay */
    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 999;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      backdrop-filter: blur(2px);
    }

    .overlay-active {
      opacity: 1;
      visibility: visible;
    }

    /* Menu Toggle Button */
    .menu-toggle {
      display: none;
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      width: clamp(32px, 8vw, 40px);
      height: clamp(32px, 8vw, 40px);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 4px;
      transition: all 0.3s ease;
      border-radius: 6px;
    }

    .menu-toggle:hover {
      transform: scale(1.05);
      background-color: rgba(0, 22, 53, 0.1);
    }

    .menu-toggle:active {
      transform: scale(0.95);
    }

    .menu-toggle span {
      display: block;
      height: 3px;
      width: 20px;
      background-color: #001635;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 2px;
      transform-origin: center;
    }

    /* Hamburger Animation */
    .menu-toggle[aria-expanded="true"] span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }

    .menu-toggle[aria-expanded="true"] span:nth-child(2) {
      opacity: 0;
      transform: scaleX(0);
    }

    .menu-toggle[aria-expanded="true"] span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }

    /* Enhanced Responsive Styles */
    @media (max-width: 1024px) {
      .container {
        padding: 0 clamp(1rem, 3vw, 1.5rem);
      }
      
      .nav-list {
        gap: clamp(0.75rem, 2vw, 1.5rem);
      }
    }

    /* Show mobile navigation on tablets and smaller */
    @media (max-width: 992px) {
      .desktop-nav {
        display: none !important;
      }

      .sidebar {
        display: block !important;
      }

      .menu-toggle {
        display: flex !important;
      }
      
      .container {
        padding: 0 clamp(0.75rem, 2vw, 1.25rem);
      }
    }

    /* Hide mobile navigation on desktop */
    @media (min-width: 993px) {
      .sidebar {
        display: none !important;
      }
      
      .menu-toggle {
        display: none !important;
      }
      
      .desktop-nav {
        display: block !important;
      }
    }

    @media (max-width: 768px) {
      .container {
        height: clamp(60px, 8vw, 70px);
      }
      
      .logo-text {
        font-size: clamp(1.1rem, 4vw, 1.5rem);
      }
      
      .logo-image {
        height: clamp(90px, 15vw, 125px);
        max-width: 420px;
      }
      
      .sidebar {
        width: min(300px, 85vw);
      }
      
      .sidebar-nav a {
        padding: clamp(1rem, 3vw, 1.25rem) clamp(1.25rem, 4vw, 1.5rem);
        font-size: clamp(0.95rem, 3vw, 1.1rem);
        min-height: 48px;
        display: flex;
        align-items: center;
      }
    }

    @media (max-width: 480px) {
      .sidebar {
        width: 100vw !important;
        right: -100vw;
      }

      .sidebar-header {
        padding: 0.75rem 1rem;
        min-height: 60px;
      }
      
      .sidebar-logo {
        font-size: 1.1rem;
      }
      
      .close-btn {
        width: 32px;
        height: 32px;
        font-size: 1.25rem;
      }

      .sidebar-nav a {
        padding: 1rem 1.25rem;
        font-size: 0.95rem;
        min-height: 48px;
      }
      
      .menu-toggle {
        width: 36px;
        height: 36px;
        padding: 6px;
      }
      
      .menu-toggle span {
        width: 18px;
        height: 2.5px;
      }
    }

    @media (max-width: 360px) {
      .container {
        padding: 0 0.75rem;
        height: 56px;
      }
      
      .logo-text {
        font-size: 1rem;
      }
      
      .logo-image {
        height: clamp(75px, 16vw, 100px);
        max-width: 330px;
      }
      
      .sidebar-header {
        padding: 0.75rem;
        min-height: 56px;
      }
      
      .sidebar-logo {
        font-size: 1rem;
      }
      
      .close-btn {
        width: 28px;
        height: 28px;
        font-size: 1.1rem;
      }
      
      .sidebar-nav a {
        padding: 0.875rem 1rem;
        font-size: 0.9rem;
        min-height: 44px;
      }
      
      .menu-toggle {
        width: 32px;
        height: 32px;
        padding: 4px;
      }
      
      .menu-toggle span {
        width: 16px;
        height: 2px;
      }
    }

    /* Touch device optimizations */
    @media (hover: none) and (pointer: coarse) {
      .nav-list a,
      .sidebar-nav a {
        min-height: 44px;
        display: flex;
        align-items: center;
      }
      
      .menu-toggle {
        min-width: 44px;
        min-height: 44px;
      }
      
      .close-btn {
        min-width: 44px;
        min-height: 44px;
      }
    }

    /* High DPI displays */
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      .menu-toggle span {
        height: 1.5px;
      }
    }

    /* Landscape orientation optimization */
    @media (orientation: landscape) and (max-width: 992px) {
      .container {
        height: clamp(60px, 8vw, 70px);
        padding: 0 clamp(0.75rem, 2vw, 1.25rem);
      }
      
      .logo-image {
        height: clamp(90px, 15vw, 130px);
        max-width: 450px;
      }
      
      .nav-list {
        gap: clamp(0.5rem, 1.5vw, 1rem);
      }
      
      .nav-list a {
        padding: clamp(0.4rem, 1vw, 0.6rem) clamp(0.6rem, 1.5vw, 0.9rem);
        font-size: clamp(0.85rem, 1.8vw, 0.95rem);
      }
    }
    
    @media (orientation: landscape) and (max-height: 500px) {
      .container {
        height: clamp(56px, 7vw, 64px);
      }
      
      .logo-image {
        height: clamp(80px, 14vw, 110px);
        max-width: 380px;
      }
    }
  `]
})
export class HeaderComponent {
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
}
